import { AdDetails } from '@/api/types/ads.types';
import { ROUTES } from '@/constants/routes';
import type { ShopSchedule } from '@/api/types/shop.types';
import { getTodayScheduleStatusFromSchedule } from '@/components/Shop/ShopScheduleModal/ShopScheduleModal.helpers';
import { QUERY } from '@/constants/common';

type TFn = (key: string, options?: Record<string, string>) => string;

export function buildWorkingScheduleStatus(
  shop: AdDetails['shop'] | undefined,
  t: TFn
) {
  if (!shop) return null;

  const useSchedule = Boolean(shop.useSchedule && shop.schedule?.length);
  if (useSchedule) {
    const today = getTodayScheduleStatusFromSchedule(
      shop.schedule as unknown as ShopSchedule[],
      t
    );
    if (!today) return null;
    return today;
  }

  return null;
}

export function buildWorkingScheduleFallbackString(shop?: AdDetails['shop']) {
  if (!shop) return '';
  return `${shop.workingDays} ${shop.workingHours}`.trim();
}

export function getUsersAdsHref(userLegacyId: number) {
  const searchParams = new URLSearchParams({
    [QUERY.userId]: userLegacyId.toString(),
  });

  return `${ROUTES.ad}?${searchParams.toString()}`;
}
